module.exports = __webpack_public_path__ + "img/item_image_8.73fdd51d.jpg";